import { MainPage } from "./main/MainPage";
import { NewsPage } from "./news/NewsPage";
import { NewsCreatePage } from "./news/NewsCreatePage";
import { NotificationCreatePage } from "./notifications/NotificationCreatePage";
import { NotificationsPage } from "./notifications/NotificationsPage";
import { FaqCreatePage } from "./faq/FaqCreatePage";
import { FaqsPage } from "./faq/FaqsPage";
import { ProfileOverviewTab } from "./profile/ProfileOverviewTab";
import { ProfileSecurityTab } from "./profile/ProfileSecurityTab";
import { ProfilePage } from "./profile/ProfilePage";
import { UsersPage } from "./users/UsersPage";
import { SosPage } from "./sos/SosPage";
import { NewsUpdatePage } from "./news/NewsUpdatePage";
import { SosViewPage } from "./sos/SosViewPage";
import { BannersPage } from "./banner/BannersPage";
import { BannerCreatePage } from "./banner/BannerCreatePage";
import { BannerUpdatePage } from "./banner/BannerUpdatePage";
import { FaqUpdatePage } from "./faq/FaqUpdatePage";
import { ChatPage } from "./chat/ChatPage";
import { SosPlacesPage } from "./sosPlaces/SosPlacesPage";
import { QuestionCreatePage } from "./questions/QuestionCreatePage";
import { QuestionsPage } from "./questions/QuestionsPage";
import { QuestionUpdatePage } from "./questions/QuestionUpdatePage";
import { CategoryCreatePage } from "./questions/category/CategoryCreatePage";
import { CoursesPage } from "./courses/CoursesPage";
import { CourseCreatePage } from "./courses/CourseCreatePage";
import { CourseUpdatePage } from "./courses/CourseUpdatePage";
import { TestCreatePage } from "./courses/tests/TestCreatePage";
import { LessonPage } from "./courses/lessons/LessonPage";
import { LessonCreatePage } from "./courses/lessons/LessonCreatePage";
import { LessonUpdatePage } from "./courses/lessons/LessonUpdatePage";
import { ResourceCreatePage } from "./courses/resources/ResourceCreatePage";
import { TestQuestionCreatePage } from "./courses/tests/TestQuestionCreatePage";
import { VictimsPage } from "./victim/VictimsPage";
import { VictimResponsePage } from "./victim/VictimResponsePage";
import { VictimStatusCreatePage } from "./victim/status/VictimStatusCreatePage";
import { VictimTypeCreatePage } from "./victim/type/VictimTypeCreatePage";
import AboutProjectPage from "./aboutProject/AboutProjectPage";
import TeamPage from "./team/TeamPage";
import { TeamCreatePage } from "./team/TeamCreatePage";
import { TeamUpdatePage } from "./team/TeamUpdatePage";
import { VoteCategoriesPage } from "./voteQuestions/VoteCategoriesPage";
import { VoteCategoryCreatePage } from "./voteQuestions/VoteCategoryCreatePage";
import { VoteCategoryUpdatePage } from "./voteQuestions/VoteCategoryUpdatePage";
import { VoteQuestionCreatePage } from "./voteQuestions/VoteQuestionCreatePage";
import { VoteReqPage } from "./voteQuestions/voteReqs/VoteReqPage";
import { VoteReqViewPage } from "./voteQuestions/voteReqs/VoteReqViewPage";

const admin = {
  MainPage,
  NewsPage,
  NewsCreatePage,
  NewsUpdatePage,
  NotificationsPage,
  NotificationCreatePage,
  FaqsPage,
  FaqCreatePage,
  ProfilePage,
  ProfileOverviewTab,
  ProfileSecurityTab,
  UsersPage,
  SosPage,
  QuestionCreatePage,
  QuestionsPage,
  SosViewPage,
  BannersPage,
  BannerCreatePage,
  BannerUpdatePage,
  FaqUpdatePage,
  ChatPage,
  SosPlacesPage,
  QuestionUpdatePage,
  CategoryCreatePage,
  CoursesPage,
  CourseCreatePage,
  CourseUpdatePage,
  TestCreatePage,
  LessonPage,
  LessonCreatePage,
  LessonUpdatePage,
  ResourceCreatePage,
  TestQuestionCreatePage,
  VictimsPage,
  VictimResponsePage,
  VictimStatusCreatePage,
  VictimTypeCreatePage,
  AboutProjectPage,
  TeamPage,
  TeamCreatePage,
  TeamUpdatePage,
  VoteCategoriesPage,
  VoteCategoryCreatePage,
  VoteCategoryUpdatePage,
  VoteQuestionCreatePage,
  VoteReqPage,
  VoteReqViewPage,
};

export default admin;
